import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconCheckboxComponent } from "./med-icon-checkbox.component";

@NgModule({
  declarations: [
    MedIconCheckboxComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconCheckboxComponent,
  ],
})
export class MedIconCheckboxModule { }
